import { Filter } from '@kanos/domain';
import { z } from 'zod';

/**
 * What a table shows, in the address (after Corly): sort, page, size, free text, filters and
 * hidden columns - a view can be bookmarked and sent along, and Back goes to the last one.
 * Values the list does not know are dropped, never an error page.
 */
export const TableSearch = z.object({
  page: z.coerce.number().int().min(1).optional().catch(undefined),
  limit: z.coerce.number().int().optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  area: z.string().optional().catch(undefined),
  outcome: z.string().optional().catch(undefined),
  actor: z.string().optional().catch(undefined),
  from: z.string().optional().catch(undefined),
  to: z.string().optional().catch(undefined),
  status: z.string().optional().catch(undefined),
  kind: z.string().optional().catch(undefined),
  /** The preselection of inquiries (ADR-068). */
  preselection: z.string().optional().catch(undefined),
  /** The rules of „Erweiterte Filter“; the router writes them into the address as JSON. */
  f: Filter.optional().catch(undefined),
  /** Hidden columns, comma-separated; empty: all shown. */
  hide: z.string().optional().catch(undefined),
  /** The tab of an area with tabs, e.g. the mails' `design`; none: its first. */
  tab: z.string().optional().catch(undefined),
});
export type TableSearch = z.infer<typeof TableSearch>;
